export default "__VITE_ASSET__DNvB5imO__"